export default __webpack_public_path__ + "static/media/advance-button.ec32fe9e.svg";